import { createSlice } from '@reduxjs/toolkit'
import name from './name'

export const author = createSlice({
  name,
  initialState: {
    authors: [],
    loaded: false
  },
  reducers: {
    setAuthors: (state, { payload }) => {
      state.authors = payload
      state.loaded = true
    },
    resetAuthors: (state) => {
      state.authors = []
      state.loaded = false
    }
  }
})

export const { setAuthors, resetAuthors } = author.actions

export default author.reducer
